import { Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/@core/services/data.service';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-editor-custom-component-feed',
  templateUrl: 'feed.component.html'
})
export class FeedComponent implements OnInit {
  @Input() item: any;
  public channels: any[] = [];
  
  public owlOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 15,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: { items: 2 },
      400: { items: 3 },
      740: { items: 4 },
      940: { items: 5 }
    },
    nav: false
  };

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.dataService.channelsAll().subscribe((res: any) => {
      this.channels = res;
    });
  }
}

